import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, throwError } from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { VcuTelemetryHistoryResponse, SseTelemetryEvent } from '../model/vcu-telemetry.model';

@Injectable({ providedIn: 'root' })
export class VcuTelemetryService {
  private readonly baseUrl: string = enviroment.BASE_URL_SSE + '/streaming/sse/telemetry';

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const idToken = sessionStorage.getItem('idToken') || '';
    return new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${idToken}`
    });
  }

  getTelemetryHistory(
    vcuId: string,
    startTime: string,
    endTime: string,
    interval: string
  ): Observable<VcuTelemetryHistoryResponse> {
    const params = new HttpParams()
      .set('vcuId', vcuId)
      .set('startTime', startTime)
      .set('endTime', endTime)
      .set('interval', interval);

    return this.http
      .get<VcuTelemetryHistoryResponse>(`${this.baseUrl}/history`, {
        headers: this.getAuthHeaders(),
        params
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getLiveStream(serialNumber: string): Observable<SseTelemetryEvent> {
    return new Observable((observer) => {
      const token = sessionStorage.getItem('idToken') || '';
      const url = `${enviroment.BASE_URL_SSE}/streaming/sse/stream/vcu/${serialNumber}?access_token=${token}`;
      const es = new EventSource(url);

      es.addEventListener('vcu-telemetry', (e: MessageEvent) => {
        try {
          observer.next(JSON.parse(e.data));
        } catch {
          // ignore malformed messages
        }
      });

      es.onerror = () => observer.error(new Error('SSE connection error'));

      return () => es.close();
    });
  }
}
